import MainSetting from '../model/MainSetting';
import { PlatformType } from '../model/PlatformType';
import { CampaignMediaEnum } from '@/campaign/main/model/CampaignApiTypes';
import { Profile } from '@/auth/signin/model/AuthTypes';
import Role from '@/auth/signin/model/Role';

class MainController {
  public onSignin(profile: Profile) {
    // 기본 값
    MainSetting.supportedMedias = [CampaignMediaEnum.KAKAO_BRANDMESSAGE, CampaignMediaEnum.TEXT_MESSAGE];
    MainSetting.showMallId = true;
    MainSetting.showSenderPhoneNumber = true;
    MainSetting.showPaymentManagement = true;
    MainSetting.mustHaveKeywordToGetProductsAtContents = false;
    MainSetting.showProductRepProductName = false;
    MainSetting.showProductSellRecommendState = true;
    MainSetting.enableCampaignMessageImageUpload = true;
    MainSetting.showRepresentProductFilterForAudience = true;
    MainSetting.showCreateDepartmentFilterForCampaignAndAudience = false;
    MainSetting.showCreateDepartmentFilterForContentsAndImage = false;
    MainSetting.showCreateDepartmentFilterForMessageTemplate = false;
    MainSetting.showProductDetailFilter = true;
    MainSetting.showDashboardCustomers = false;
    MainSetting.showMediaManagement = true;
    MainSetting.showDataConnection = true;
    MainSetting.showBehaviorDataScript = false;
    MainSetting.buyPlanUsingCredit = false;


    if (profile.platform_type === PlatformType.cafe24) {
      MainSetting.showBehaviorDataScript = true;
    } 
    else if (profile.platform_type === PlatformType.imweb) { 
      MainSetting.buyPlanUsingCredit = true;
    }
    else if (profile.platform_type === PlatformType.hmall) {
      MainSetting.supportedMedias = [CampaignMediaEnum.TEXT_MESSAGE];
      MainSetting.showMallId = false;
      MainSetting.showSenderPhoneNumber = false;
      MainSetting.showPaymentManagement = false;
      MainSetting.mustHaveKeywordToGetProductsAtContents = true;
      MainSetting.showProductSellRecommendState = false;
      MainSetting.enableCampaignMessageImageUpload = false;
      MainSetting.showDataConnection = false;
      MainSetting.showMediaManagement = false;
    } 
    else if (profile.platform_type === PlatformType.larosee) {
      MainSetting.showMallId = false;
      MainSetting.showSenderPhoneNumber = false;
      MainSetting.showPaymentManagement = false;
      MainSetting.mustHaveKeywordToGetProductsAtContents = true;
      MainSetting.showProductSellRecommendState = false;
      MainSetting.showRepresentProductFilterForAudience = false;
      MainSetting.showCreateDepartmentFilterForCampaignAndAudience = profile.role === Role.admin;
      MainSetting.showCreateDepartmentFilterForContentsAndImage = true;
      MainSetting.showCreateDepartmentFilterForMessageTemplate = true;
      MainSetting.showProductDetailFilter = false;
      MainSetting.showDashboardCustomers = true;
      MainSetting.showMediaManagement = false;
      MainSetting.showDataConnection = false;
    } 

    // 매체, 데이터 연동 중 한개라도 보여주는 경우에만 설정을 보여준다.
    MainSetting.showSetting = profile.role === Role.admin && (MainSetting.showMediaManagement || MainSetting.showDataConnection);
  }
}

export const PATH = {
  ROOT: '/',
  LOGIN: '/login',
  TERM_ONBOARDING: '/term/onboarding',
  TERM_PAYMENT: '/term/payment',
  TERM_PRIVACY: '/term/privacy',
  RESET_PASSWORD: '/reset-password',
  CAFE24_APP: '/cafe24-app',
  JOIN_FROM_PLATFORM: '/auth/join-from-platform',
  JOIN_PREPARED: '/auth/join-prepared',
  MAIN: '/main',
  AUTH_REDIRECT: '/main/auth/redirect',
  ONBOARDING: '/main/onboarding',
  CAMPAIGN_INDEX: '/main/campaign',
  CAMPAIGN_CREATE: '/main/campaign/create',
  CAMPAIGN_DETAIL: '/main/campaign/:id',
  STRATEGY_MANAGER_INDEX: '/main/strategy-manager',
  STRATEGY_MANAGER_CREATE: '/main/strategy-manager/create',
  STRATEGY_MANAGER_DETAIL: '/main/strategy-manager/:id',
  TARGET_AUDIENCE_INDEX: '/main/audience',
  TARGET_AUDIENCE_CREATE: '/main/audience/create',
  TARGET_AUDIENCE_DETAIL: '/main/audience/:id',
  CONTENTS_MANAGER_INDEX: '/main/contents-manager',
  CONTENTS_MANAGER_CONTENTS_INDEX: '/main/contents-manager/contents',
  CONTENTS_MANAGER_CONTENTS_CREATE: '/main/contents-manager/contents/create',
  CONTENTS_MANAGER_CONTENTS_DETAIL: '/main/contents-manager/contents/:id',
  CONTENTS_MANAGER_LIBRARIES_INDEX: '/main/contents-manager/libraries',
  CONTENTS_MANAGER_PRODUCTS_INDEX: '/main/contents-manager/products',
  CONTENTS_MANAGER_PRODUCTS_DETAIL: '/main/contents-manager/products/:id',
  SETTINGS: '/main/settings',
  MESSAGE_TEMPLATE: '/main/message-templates',
  USER: '/main/users',
  UNAUTHORIZED: '/main/unauthorized',
  DASHBOARD_INDEX: '/main/dashboard',
  DASHBOARD_CAMPAIGN_ANALYSIS: '/main/dashboard/campaign-analysis',
  DASHBOARD_SENDING_SET_ANALYSIS: '/main/dashboard/sending-set-analysis',
  DASHBOARD_TREND_ANALYSIS: '/main/dashboard/trend-analysis',
  DASHBOARD_AUDIENCE_ANALYSIS: '/main/dashboard/audience-analysis',
  DASHBOARD_CUSTOMERS: '/main/dashboard/customers',
  DASHBOARD_CUSTOMER_ANALYSIS: '/main/dashboard/customer-analysis',
  DASHBOARD_AGENT: '/main/dashboard/agent',
  BILLING_OVERVIEW: '/main/billing',
  BILLING_PAYMENT_SUCCESS: '/main/billing/payment-success',
  BILLING_PAYMENT_FAIL: '/main/billing/payment-fail',
} as const;

export const getRedirectPath = (location: Location) => {
  return new URLSearchParams(location.search).get('redirect') || PATH.MAIN;
};

export default new MainController();
